module.exports = __webpack_public_path__ + "img/vignettes-asso_0011_agir-pur-lecole.fe732e63.jpg";